const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: '42f731815804618872f9aeab9511cc98',
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`
}

export default apiConfig;